'use client'

import React, { useEffect, useRef } from 'react'
import { LinkItem } from '@/app/_components/layout/LinkItem'
import { useCategories } from '@/hooks/useCategories'

type ShoppingMenuProps = {
  isOpen: boolean
  onClose?: () => void
}

export const ShoppingMenu: React.FC<ShoppingMenuProps> = (props) => {
  const { isOpen, onClose } = props
  const { categories, loading } = useCategories()

  const menuRef = useRef<HTMLDivElement>(null)

  // メニュー外側のクリックを検知してメニューを閉じる
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target as Node)
      ) {
        onClose?.()
      }
    }

    if (isOpen) {
      document.addEventListener('click', handleClickOutside)
    }

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [isOpen, onClose])

  if (loading) {
    return null
  }

  return (
    <div
      ref={menuRef}
      className={`hidden lg:flex items-center justify-center absolute top-[89px] transition-all duration-500 ease-out w-full bg-background pt-11 pb-[93px] ${
        isOpen
          ? 'opacity-100 transform translate-y-0'
          : 'opacity-0 transform -translate-y-4 pointer-events-none'
      }`}
    >
      <div className="flex justify-between max-w-[1000px] w-full mx-auto">
        <div className="flex flex-col items-start">
          <p className="font-bold text-sm mb-2">NEW ARRIVALS</p>
          <LinkItem
            href="/listings?gender=1"
            text="ウィメンズ"
            className="text-xs leading-8 font-bold"
            onClick={onClose}
          />
          <LinkItem
            href="/listings?gender=0"
            text="メンズ"
            className="text-xs leading-8 font-bold"
            onClick={onClose}
          />
          <LinkItem
            href="/listings?gender=2"
            text="キッズ"
            className="text-xs leading-8 font-bold"
            onClick={onClose}
          />
        </div>

        <div className="flex flex-col items-start">
          <p className="font-bold text-sm mb-2">ウィメンズ</p>
          {categories.parka && (
            <LinkItem
              href={`/listings?gender=1&categories=${categories.parka}`}
              text="パーカ（ダウン）"
              className="text-xs leading-8 font-bold"
              onClick={onClose}
            />
          )}
          {categories.bomber && (
            <LinkItem
              href={`/listings?gender=1&categories=${categories.bomber}`}
              text="ボンバー"
              className="text-xs leading-8 font-bold"
              onClick={onClose}
            />
          )}
          {categories.lightweight && (
            <LinkItem
              href={`/listings?gender=1&categories=${categories.lightweight}`}
              text="ライトウェイトダウンジャケット"
              className="text-xs leading-8 font-bold"
              onClick={onClose}
            />
          )}
          {categories.puffer && (
            <LinkItem
              href={`/listings?gender=1&categories=${categories.puffer}`}
              text="パッファージャケット"
              className="text-xs leading-8 font-bold"
              onClick={onClose}
            />
          )}
          {categories.rainWind && (
            <LinkItem
              href={`/listings?gender=1&categories=${categories.rainWind}`}
              text="レイン＆ウィンド"
              className="text-xs leading-8 font-bold"
              onClick={onClose}
            />
          )}
          {categories.vest && (
            <LinkItem
              href={`/listings?gender=1&categories=${categories.vest}`}
              text="ベスト"
              className="text-xs leading-8 font-bold"
              onClick={onClose}
            />
          )}
        </div>

        <div className="flex flex-col items-start">
          <p className="font-bold text-sm mb-2">メンズ</p>
          {categories.parka && (
            <LinkItem
              href={`/listings?gender=0&categories=${categories.parka}`}
              text="パーカ（ダウン）"
              className="text-xs leading-8 font-bold"
              onClick={onClose}
            />
          )}
          {categories.bomber && (
            <LinkItem
              href={`/listings?gender=0&categories=${categories.bomber}`}
              text="ボンバー"
              className="text-xs leading-8 font-bold"
              onClick={onClose}
            />
          )}
          {categories.lightweight && (
            <LinkItem
              href={`/listings?gender=0&categories=${categories.lightweight}`}
              text="ライトウェイトダウンジャケット"
              className="text-xs leading-8 font-bold"
              onClick={onClose}
            />
          )}
          {categories.puffer && (
            <LinkItem
              href={`/listings?gender=0&categories=${categories.puffer}`}
              text="パッファージャケット"
              className="text-xs leading-8 font-bold"
              onClick={onClose}
            />
          )}
          {categories.rainWind && (
            <LinkItem
              href={`/listings?gender=0&categories=${categories.rainWind}`}
              text="レイン＆ウィンド"
              className="text-xs leading-8 font-bold"
              onClick={onClose}
            />
          )}
          {categories.vest && (
            <LinkItem
              href={`/listings?gender=0&categories=${categories.vest}`}
              text="ベスト"
              className="text-xs leading-8 font-bold"
              onClick={onClose}
            />
          )}
        </div>

        <div className="flex flex-col items-start">
          <p className="font-bold text-sm mb-2">キッズ</p>
          {categories.outerwear && (
            <LinkItem
              href={`/listings?gender=2&categories=${categories.outerwear}`}
              text="アウターウェア"
              className="text-xs leading-8 font-bold"
              onClick={onClose}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ShoppingMenu
